/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const onCreateChatMessage = /* GraphQL */ `
  subscription OnCreateChatMessage {
    onCreateChatMessage {
      id
      content
      author
      roomId
      createdAt
      updatedAt
    }
  }
`;

export const onCreateChatMessageRoomFilter = `
subscription MySubscription($roomId:String!) {
  onCreateChatMessageRoomFilter(roomId:$roomId) {
    updatedAt
    roomId
    id
    createdAt
    content
    author
  }
}
`;

export const onUpdateChatMessage = /* GraphQL */ `
  subscription OnUpdateChatMessage {
    onUpdateChatMessage {
      id
      content
      author
      roomId
      createdAt
      updatedAt
    }
  }
`;
export const onDeleteChatMessage = /* GraphQL */ `
  subscription OnDeleteChatMessage {
    onDeleteChatMessage {
      id
      content
      author
      roomId
      createdAt
      updatedAt
    }
  }
`;
